import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { GlobalService } from '../../services/global.service';
import { MLService } from '../../services/ml-service';
import { moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { PlatformComponent } from '../../models/workflow/Model.model';
import { InputParameter } from '../../models/workflow/inputParameters.model';
import { DataSrc } from '../../models/workflow/workflow.model';
import { OutputParameter } from '../../models/workflow/outputParameters.model';
import { WorkflowEventsHandler } from '../../workflow/workflow-events/workflow.events.handler';
import { ParameterModel } from 'src/app/models/workflow/parameter.model';

@Component({
  selector: 'app-connector-specification',
  templateUrl: './connector-specification.component.html',
  styleUrls: ['./connector-specification.component.css']
})
export class ConnectorSpecificationComponent implements OnInit {

  srcModel = new PlatformComponent();
  srcOutputParameters: OutputParameter[] = [];
  srcConnParameterList: OutputParameter[] = [];
  deletedSrcParam: OutputParameter;
  sinkModel = new PlatformComponent();
  sinkInputParameters: InputParameter[] = [];
  sinkConnParameterList: InputParameter[] = [];
  deletedSinkParam: InputParameter;
  readOnly = false;
  parameterModel = new ParameterModel();

  constructor(public dialogRef: MatDialogRef<ConnectorSpecificationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public globals: GlobalService,
    public flowSheetHandler: WorkflowEventsHandler,
    public mlService: MLService,
    public dialog: MatDialog) {
  };

  ngOnInit() {

    this.srcModel = this.data.srcModel;
    this.sinkModel = this.data.sinkModel;
    this.readOnly = this.data.readOnly;
    this.setSrcParameters();
    this.setSinkParameters();
  }

  setSrcParameters() {
    this.srcOutputParameters = this.srcModel.outputParameters
      .filter(p => this.sinkModel.inputParameters
        .findIndex(ip => ip.mappedDataSource == DataSrc.component && ip.mappedDataSourceId == this.srcModel.componentUniqueId
          && ip.mappedParameterId == p.data.parameterId) == -1);

    this.sinkModel.inputParameters.filter(p => p.mappedDataSource == DataSrc.component
      && p.mappedDataSourceId == this.srcModel.componentUniqueId).forEach((sinkParam) => {
        this.srcConnParameterList.push(this.srcModel.outputParameters.find(p => p.data.parameterId == sinkParam.mappedParameterId));
      });
  }

  setSinkParameters() {
    this.sinkInputParameters = this.sinkModel.inputParameters.filter(p => p.mappedDataSource == DataSrc.user);
    this.sinkConnParameterList = this.sinkModel.inputParameters.filter(p => p.mappedDataSource == DataSrc.component
      && p.mappedDataSourceId == this.srcModel.componentUniqueId);
  }

  drop(event) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }

  onCancelClick() {
    this.dialogRef.close(false);
  }

  deleteMapping(index) {
    this.deletedSinkParam = this.sinkConnParameterList.splice(index, 1)[0];
    this.flowSheetHandler.resetParameterSrcMapData(this.deletedSinkParam);
    this.flowSheetHandler.returnParameterToOriginalPosition(this.sinkInputParameters, this.deletedSinkParam);
    if (this.srcConnParameterList[index]) {
      this.deletedSrcParam = this.srcConnParameterList.splice(index, 1)[0];
      this.flowSheetHandler.returnParameterToOriginalPosition(this.srcOutputParameters, this.deletedSrcParam);
    }
  }

  saveConnectorSpecification() {
    this.sinkConnParameterList.forEach((connParam, index) => {
      let srcParam = this.srcConnParameterList[index];
      this.parameterModel.model = this.sinkModel;
      this.parameterModel.parameterId = connParam.data.parameterId;
      this.parameterModel.dataSource = DataSrc.component;
      this.parameterModel.dataSourceId = this.srcModel.componentUniqueId;
      this.parameterModel.srcFrequency = 0;
      this.parameterModel.srcParameterId = srcParam.data.parameterId;
      this.parameterModel.srcParameterName = srcParam.data.parameterName;
      this.parameterModel.defaultValue = connParam.data.parameterDefaultValue;
      this.flowSheetHandler.updateParameterMapping(this.parameterModel);
    });
    this.dialogRef.close(false);
  }

}
